import { Table as SemanticTable } from "semantic-ui-react";
import { ClearableCheckboxDropdown, Table } from "dyl-components";
import { useNavigate, useSearchParams } from "react-router-dom";
import SortActions from "pages/Groups/subcomponents/SortActions";
import { useState } from "react";
import { useSelector } from "react-redux";
import { PhoneUtil } from "utils";

const UsageStatsTextsTableHeader = ({ onFilter }) => {
    const [params] = useSearchParams();
    const navigate = useNavigate()
    const routeRoot = "/settings/usage-stats/texts"
    const [createdOrder, setCreatedOrder] = useState(
        params.get("order_by") === "created" && params.get("order") === "asc"
    );
    const { contactPhones = [], phones = [], textUsers = [] } = useSelector(state => state.text);
    const toOptions = contactPhones.map((contact,idx) => {
        return {
            key: idx,
            value: contact,
            text: PhoneUtil.formatPhoneNumber(contact),
        }
    });
    const fromOptions = phones.map((phone) => {
        return {
            key: phone,
            value: phone,
            text: PhoneUtil.formatPhoneNumber(phone),
        }
    });

    const textUsersOptions = textUsers.map((user) => {
        return {
            key: user.id,
            value: `${user.id}`,
            text: user.first_name + " " + user.last_name,
        }
    });

    const createdOrderFilter = () => {
        setCreatedOrder(!createdOrder);
        const query = new URLSearchParams(params);
        const order = !createdOrder ? "asc" : "desc";
        query.set("order", order);
        const query_string = query.toString();
        navigate(`${routeRoot}${query_string ? `?${query_string}` : ''}`);
    };
    const users = params.get('user_id')?.split(',');
    return (
        <Table.Row>
            <SemanticTable.HeaderCell className='ModulesListTable__MediumFixedWidth' width={2}>
                <span style={{ marginRight: 5 }}>Date</span>

                <SortActions
                    direction={createdOrder}
                    onToggleSort={() => {
                        createdOrderFilter();
                    }}
                />
            </SemanticTable.HeaderCell>

            <SemanticTable.HeaderCell className='ModulesListTable__MediumFixedWidth' width={3}>
                <ClearableCheckboxDropdown
                    text='Contact/Account'
                    name='contact_phone'
                    options={toOptions}
                    onChange={(_, { value }) => { onFilter(_, { name: 'contact_phone', value }) }}
                    value={params.get('contact_phone')?.split(',')}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className='ModulesListTable__MediumFixedWidth' width={2}>
                <ClearableCheckboxDropdown
                    text='Number'
                    name='customer_phone'
                    options={fromOptions}
                    onChange={(_, { value }) => { onFilter(_, { name: 'customer_phone', value }) }}
                    value={params.get('customer_phone')?.split(',')}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className='ModulesListTable__MediumFixedWidth' width={2}>
                <ClearableCheckboxDropdown
                    text='User'
                    name='user_id'
                    options={textUsersOptions}
                    onChange={(_, { value }) => { onFilter(_, { name: 'user_id', value }) }}
                    value={users}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className='ModulesListTable__SmallFixedWidth' width={2}>
                Message Type
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className='ModulesListTable__MediumFixedWidth' width={2}>
                Replenish
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className='ModulesListTable__MediumFixedWidth' width={2}>
                Charge
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell className='ModulesListTable__MediumFixedWidth' width={2}>
                Balance
            </SemanticTable.HeaderCell>
        </Table.Row>
    );
};

export default UsageStatsTextsTableHeader;
